import { useSwiper } from "swiper/react";
export const SwiperButtonNext = ({ text }: any) => {
  const swiper = useSwiper();
  return <button onClick={() => swiper.slideNext()}>{text}</button>;
};
